import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SecureGate } from "@/components/SecureGate";
import { RouteMap, DaysTable, StopsList } from "@/pages/admin/AdminRoutes";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

function DayRoute({ tech, cell }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    let live = true;
    api.get("/admin/tracking/range", { params: { technician_id: tech.id, start: `${cell.date}T00:00`, end: `${cell.date}T23:59` } })
      .then((r) => live && setData(r.data)).catch((e) => live && setErr(errMsg(e)));
    return () => { live = false; };
  }, [tech.id, cell.date]);
  if (err) return <p className="text-sm text-red-600">{err}</p>;
  if (!data) return <p className="flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> Ricostruisco il percorso…</p>;
  return (
    <div className="space-y-3" data-testid="day-route">
      <p className="text-sm text-slate-600">
        Entrata <b>{cell.first_in || "—"}</b> · Uscita <b>{cell.last_out || "—"}</b>
        {cell.lunch_hours > 0 && <> · pausa {cell.lunch}</>} · netto <b>{Math.floor(cell.hours)}h {String(Math.round((cell.hours % 1) * 60)).padStart(2, "0")}m</b>
        {cell.place && <> · {cell.place}</>}
      </p>
      {data.points.length ? <RouteMap data={data} height="h-[340px]" /> : null}
      <div className="grid gap-3 md:grid-cols-2"><DaysTable data={data} /><StopsList stops={data.stops} /></div>
    </div>
  );
}

export function DayRouteDialog({ target, onClose }) {
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-4xl overflow-y-auto" data-testid="day-route-dialog">
        {target && (
          <>
            <DialogHeader><DialogTitle className="capitalize">{target.tech.name} · {fmtDate(target.cell.date, { weekday: "long", day: "numeric", month: "long" })}</DialogTitle></DialogHeader>
            <SecureGate><DayRoute tech={target.tech} cell={target.cell} /></SecureGate>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
